import styled from 'styled-components';
import { BODY_COLOR_OPACITY } from '@/components/DesignSystem/ModernTheme/utils/common';
export const FormContainer = styled.div`
  padding: 2.5rem;
  width: 100%;
  border: 0.4px solid ${(props) => props?.themeStyle?.borderColor};
  background: ${(props) => props?.themeStyle?.backgroundColor};
  border: none;
  height: 100%;
`;

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

export const FormHeadingContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  height: 350px;
`;

export const CompletionImage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

export const FormHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
  font-size: 40px;
  font-style: normal;
  line-height: normal;
  font-weight: ${(props) => props?.textStyles?.heading?.fontWeight || '700'};
  color: ${(props) => props?.textStyles?.heading?.color || '#FFFF00'};
  font-family: ${(props) => props?.textStyles?.heading?.fontFamily || 'Arial'};
  overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
  overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
`;

export const FormDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.503px;
  opacity: ${BODY_COLOR_OPACITY};
  color: ${(props) => props?.textStyles?.body?.color || '#FFFF00'};
  font-family: ${(props) => props?.textStyles?.body?.fontFamily || 'Arial'};
  overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
  overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
`;

export const FormCTAButtons = styled.section``;
export const CTAButton = styled.button`
  width: 100%;
  padding: 1rem 0.75rem;
  text-align: center;
  cursor: pointer;
  //   font-family: DM Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.503px;
  background: ${(props) => props?.themeStyles?.buttonSecondary?.backgroundColor};
  border: 1px solid ${(props) => props?.themeStyles?.buttonSecondary?.borderColor};
  color: ${(props) => props?.themeStyles?.buttonSecondary?.borderColor};
  font-size: ${(props) => props?.themeStyles?.buttonSecondary?.textFontSize || 1}rem;
  font-family: ${(props) => props?.themeStyles?.buttonSecondary?.fontFamily || 'Arial'};
  &:hover {
    background: ${(props) => props?.themeStyles?.buttonSecondary?.borderColor};
    transition: background 0.5s ease-in-out;
    color: ${(props) => props?.themeStyles?.buttonPrimary?.color};
  }
`;

export const FormInputContainer = styled.section`
  width: 100%;
  display: flex;
  gap: 1rem;
  flex-direction: column;
`;

export const InputTextContainer = styled.div`
  width: 100%;
`;
